import React, { useState } from 'react';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import { trackWithFingerprint } from '../../../../utils/trackWithFingerprint';
import { CopyLinkIcon } from './SocialIcons';
import { SocialIconWrapper } from './SocialIconWrapper';

export function ShareButton() {
  const [id] = useState('blog-share-button');
  const [tooltipOpen, setTooltipOpen] = useState<boolean | undefined>(false);

  return (
    <button
      id={id}
      type="button"
      onClick={() => {
        setTooltipOpen(true);
        navigator.clipboard?.writeText(window.location.href);
        trackWithFingerprint('CTA Clicked', {
          blog_share_type: 'Share Link',
          module: 'blog_share_icon'
        });
      }}
      onMouseLeave={() => setTooltipOpen(false)}
    >
      <SocialIconWrapper>
        <CopyLinkIcon
          alt="share icon"
          className="text-white hover:text-[#99E4D7]"
        />
      </SocialIconWrapper>
      <Tooltip
        anchorSelect={`#${id}`}
        content="Link copied!"
        place="top"
        isOpen={tooltipOpen}
        className="rounded-[12px]"
      />
    </button>
  );
}
